var poll_default = {
  "fontElementMap": "IvXw8",
  "container": "_119rX",
  "fullscreen": "_2lryr",
  "background_overlay": "XECMh",
  "with_image": "_5m7XC",
  "options": "nyEtN",
  "webview": "mAJFr",
  "grid": "dhI0m",
  "option": "NSy-Y",
  "cta_button": "fBApT",
  "add_option": "OGnbR",
  "see_more": "_8pvHl",
  "list": "Cc-yJ",
  "column": "-lEG5",
  "additional_note": "PCUSZ",
  "spinner": "YVBrv",
  "spin": "B69Fo",
  "shown": "ZcZT0",
  "error": "-yrBH"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
